<template>

    <fragment v-if="((!addopinion && !loading) || (addopinion))">

        <MglMap :mapboxGl="mapboxgl" :data-slideID="slide.id" :ref="`gmap-${slide.id}`" @load="onMapLoaded"
            :container="'gmap-' + slide.id" :accessToken="accessToken" :mapStyle.sync="mapStyle"
            :center="dataStore.currentMapCenter ? [parseFloat(dataStore.currentMapCenter.lng), parseFloat(dataStore.currentMapCenter.lat)] : [parseFloat(slide.center_lng), parseFloat(slide.center_lat)]"
            :zoom="currentMapZoom" :minZoom="5" :preserveDrawingBuffer="true"
            :maxZoom="zoomDefault.maxZoom">
            <MglNavigationControl position="bottom-right" />

            <div>

                <MglMarker :v-if="isMarker && dataStore.collectedAnswers.length > 0 && addOpinion"
                    :draggable="addOpinion"
                    v-on:drag="addOpinion ? setCoordinates($event, m, slide, markerindex) : false"
                    v-on:dragend="addOpinion ? setCoordinates($event, m, slide, markerindex) : false"
                    v-on:click="toggleOpinion(m)" :key="markerindex" :ref="`marker-${markerindex}`"
                    v-for="(m, markerindex) in dataStore.collectedAnswers.filter(item => item.item_id === slide.id)"
                    :coordinates="[parseFloat(m.lng), parseFloat(m.lat)]">
                    <img class="map-marker" :src="`${getPinImage(m)}`" slot="marker" />
                    <!-- v-if="(m.lat === dataStore.infoWindowPos.lat) && (m.lng === dataStore.infoWindowPos.lng)" -->
                    <MglPopup :ref="`infowindow`" :showed="addOpinion" @removed="onRemovedPopup" @add="onAddPopup"

                        @open="onOpenPopup" @close="onClosePopup" :close-button="false" :closeOnClick="false">

                        <div v-if="addOpinion" class="window">
                            <form-pop-up :slide="slide" :parentslug="slug" :index="index" @close-popup="closePopup" />
                        </div>

                        <div v-else>
                            <current-opinion-window :index="index" :project="project" :slide="slide"
                                @close-popup="closePopup" />
                        </div>

                    </MglPopup>

                    <!-- :offset="[ dataStore.infoWindowPos.lat, dataStore.infoWindowPos.lng ]" -->
                </MglMarker>

                <MglMarker
                    v-if="myPosition" :coordinates="myPosition">
                    <img class="map-marker my-position" :src="'/images/my_position.png'" slot="marker" />
                </MglMarker>

                
               <template v-if="dataStore.showOnMapPopup && dataStore.showOnMapPopupMarker">

                   <MglMarker v-if="!dataStore.addToExistingWindow" :coordinates="[parseFloat(dataStore.showOnMapPopupMarker.lng), parseFloat(dataStore.showOnMapPopupMarker.lat)]">
                                        
                        <img class="map-marker" :src="'/images/deeplink.png'" slot="marker" />

                        <MglPopup 
                            :ref="`infowindow`" :showed="dataStore.showOnMapPopup" @removed="onRemovedPopup" @add="onAddPopup"
                            @open="onOpenPopup" @close="onClosePopup" :close-button="false" :closeOnClick="false"> 
                            <current-opinion-window :index="index" :project="project" :slide="slide" @close-popup="closePopup" />
                        </MglPopup>
    
                   </MglMarker>

               </template>

            </div>

        </MglMap>

    </fragment>

</template>

<script>

const { point, polygon } = require('@turf/helpers')

import L from 'leaflet'

import booleanPointInPolygon from '@turf/boolean-point-in-polygon'

import mapboxgl from 'mapbox-gl'

import { MglMap, MglNavigationControl, MglGeolocateControl, MglPopup, MglMarker } from 'vue-mapbox'

import dataStore from '../../store'

import { markerObject, hideHint, addAnswer, toggleOpinionForm, getSearchParameters } from '../../functions'

import { mapBoxFilter } from '../../map-functions'

import { infoOptions } from '../../settings'

import mapBoxSettings from './../../../mapbox-settings'

import * as mapStyle from './../../../mapbox-style.json'

import currentOpinionWindow from './../layout/currentOpinionWindow'

import FormPopUp from './../layout/FormPopUp'

import { Fragment } from 'vue-fragment'

import { MapboxSearchBox } from '@mapbox/search-js-web'

export default {

    inject: ['loading', 'language'],

    components: {

        currentOpinionWindow,

        FormPopUp,

        Fragment,

        MglMap,

        MglNavigationControl,

        MglGeolocateControl,

        MglPopup,

        MglMarker

    },

    data() {

        return {

            dataStore,

            accessToken: mapBoxSettings.accessToken,

            mapStyle: Object.assign({}, mapStyle),

            infoOptions: infoOptions,

            zoomDefault : {
                zoom : 8,
                maxZoom : 18
            },

            map: null,

            mapbox: null,

            mapboxgl,

            currentPopup: null,

            lastMarker: null, // when drag and drop

            flying: false,

            searchControl : null,

            // helpers for filter - options

            goodOptions: [],

            badOptions: [],

            myPosition : null,

            // turf for mapbox
            point,

            polygon,

            booleanPointInPolygon,

        }

    },

    props: {

        project: Object,

        slide: Object,

        getPinImage: Function,

        addopinion: Boolean,

        slug: String,

        index: Number

    },

    watch: {

        toggleHeatMap: function (val) {

            if (this.dataStore.currentSlide.type !== 'map' || !this.map) return

            this.map.setLayoutProperty('heatmap', 'visibility', 'visible');

            this.applyFilters( this.dataStore.selectedFilters )

        },

        toggleFilters: function (values) {

            if (this.dataStore.currentSlide.type !== 'map' || window.location.pathname.includes('preview-project-report')) return

            this.applyFilters(values)

        }

    },

    mounted() {

        this.goodOptions = this.slide.question.options.filter(option => option.type === 'good').map(option => option.id)

        this.badOptions = this.slide.question.options.filter(option => option.type === 'bad').map(option => option.id)

        this.beforeChange()

        this.afterChange()

        this.loadingDone()

    },


    computed: {

        toggleFilters: function () {
            return this.dataStore.selectedFilters
        },

        toggleHeatMap: function () {
            return this.dataStore.viewActive.heatmap
        },
        
        addOpinion: function () {
            return this.addopinion ? true : false
        },

        isMarker: function () {
            return Array.isArray(this.dataStore.collectedAnswers)
        },

        currentMapZoom: function() {
            return this.dataStore.currentMapZoom ? this.dataStore.currentMapZoom : this.zoomDefault.zoom
        },

        currentOpinion() {
            
            const opinion = this.dataStore.currentOpinion;

            if (Array.isArray(opinion) && opinion.length) {
                const first = opinion[0];
                return (first && first.lat && first.lng) ? first : null;
            }

            return (opinion && typeof opinion.lat === 'number' && typeof opinion.lng === 'number') ? opinion : null;
        }

    },
    
    methods: {

        // togglePopup() {
        //     console.log('Toggle popup', this.dataStore.currentOpinion)

        //     this.showPopup = !this.showPopup
        // },

        // ## MAPBOX ##

        // onLoad function from mapbox

        onMapLoaded: async function (event) {

            this.map = event.map

            this.mapbox = event.component.mapbox

            if (this.dataStore.currentSlide && this.dataStore.currentSlide.type !== 'map') return

            await this.tiggerOnInit()
        },

        searchBox: function() {

            if( ! this.slide.show_navigation_coordinates ) return

            if( this.searchControl !== null ) {
                this.map.removeControl(this.searchControl)                
                this.searchControl = null
            }

            this.searchControl = new MapboxSearchBox()

            this.searchControl.options = {
                language : 'sv',
                country : 'SE',
                types: ['place', 'street', 'address', 'district', 'locality', 'neighborhood', 'block']  // country, region, postcode
            }
            
            this.searchControl.accessToken = this.accessToken

            this.searchControl.placeholder = this.language.search

            if( this.getBounds() ) {
                this.searchControl.options.proximity = [this.slide.center_lng, this.slide.center_lat]
                const { _sw, _ne } =  this.getBounds()
                this.searchControl.options.bbox = [ _sw.lng, _sw.lat, _ne.lng, _ne.lat ]
            }
            
            // top-left, top-right, bottom-left, bottom-right
            this.map.addControl(this.searchControl, 'top-left')

        },

        tiggerOnInit: async function () {

            // if( this.dataStore.currentSlide.type !== "map" ) return

            this.fitBounds()

            this.map.on('zoomend', () => this.zoom_changed())

            this.map.on('flystart', (marker) => {
                this.flying = marker;
            });

            this.map.on('flyend', () => {
                this.flying = false;
            });

            this.map.on('moveend', (e) => {

                if (this.flying) {

                    const marker = this.flying

                    this.currentPopup = {
                        id: marker.id,
                        coordinates: [parseFloat(marker.lng), parseFloat(marker.lat)],
                        custom: true
                    }

                    this.map.fire('flyend');

                }


            });

            if (this.mapPathsItem().length && this.dataStore.showPolygon) {

                if (this.map && !this.map.getSource('polygon-source')) {

                    this.map.addSource('polygon-source', {
                        'type': 'geojson',
                        'data': {
                            'type': 'Feature',
                            'geometry': {
                                'type': 'Polygon',
                                'coordinates': this.mapPathsItem()
                            }
                        }
                    })

                }

                if (this.map && !this.map.getLayer('polygon-figure')) {

                    this.map.addLayer({
                        'id': 'polygon-figure',
                        'type': 'fill',
                        'source': 'polygon-source',
                        'layout': {},
                        'paint': {
                            'fill-opacity': 0
                        }
                    })

                }

                if (this.map && !this.map.getLayer('polygon-outline')) {

                    this.map.addLayer({
                        'id': 'polygon-outline',
                        'type': 'line',
                        'source': 'polygon-source',
                        'layout': {},
                        'paint': {
                            'line-color': '#fff',
                            'line-width': 3
                        }
                    })

                }

            }

            // http://placetoplan.test/admin/pdf/preview-project-report/jaktvarvet/good/74/0/?pdf_user=rickard@oawa.se&pdf_pass=jcLiQt2xwbYQJq6HbwmxHgVq

            if (this.addOpinion) {
                this.map.on('click', (e) => this.addMarker(e))
            } else {

                this.map.on('click', (e) => {
                    hideHint(this.slug, this.slide.id)
                })

                if (!this.map.getSource('places')) {
                    this.addSource()
                }

            }

            try {

                const position = await this.getMyPosition()

                    const data = position.coords

                    this.myPosition = [ data.longitude, data.latitude ]

                    // var el = document.createElement('div');
                    // el.className = 'marker';
                    // el.style.backgroundImage = 'url(https://placetoplan.test/images/my_position.png)';
                    // el.style.width = '32px';
                    // el.style.height = '40px';
                    
                    // this.map.addLayer({ id: 'my-position', type: 'symbol', source : 'places', paint: { 'icon-image': 'my_position' }})
    
                    // new mapboxgl.Marker(el).setLngLat([ data.longitude, data.latitude ]).addTo(this.map)

                    // this.map.addSource('points', {
                    //     'type': 'geojson',
                    //     'data': {
                    //     type: 'FeatureCollection',
                    //     features: [
                    //         {
                    //             type: 'Feature',
                    //             // properties : {
                    //             //     icon : 'theatre'
                    //             // },
                    //             geometry: {
                    //                 type: 'Point',
                    //                 coordinates: [ data.longitude, data.latitude ]
                    //             }
                    //         }
                    //     ]
                    // }
                    // })

                    // this.map.addLayer({
                    //     id : 'points',
                    //     type : 'symbol',
                    //     source : 'points',
                    //     layout : {
                    //         'icon-image' : 'my_position'
                    //     },
                    //     'paint': {
                    //         'icon-opacity': 1
                    //     }
                    // });


            } catch (err) {
                console.error(err);
            }

            window.addEventListener('resize', () => this.map.resize() )

            this.searchBox()

            if( this.dataStore.showOnMapPopup ) {

                this.map.jumpTo({
                    center: [parseFloat(this.currentOpinion.lng), parseFloat(this.currentOpinion.lat)],
                    zoom: this.map.getMaxZoom()
                })

            }

        },

        fitBounds: function() {

            const bounds = this.getBounds()

            if (bounds && this.map) {
                this.map.fitBounds(bounds, { padding: 32, duration: 0 })
            }

        },

        // Add markers on map
        addMarker: function (event) {

            const alreadyInBag = this.dataStore.collectedAnswers.filter(item => item.item_id === this.slide.id)

            // only allow to answer a certain amount answers - change in admin

            if (alreadyInBag.length == this.slide.amount_of_answers && this.slide.question && this.slide.question.limit_markers) return

            if (this.dataStore.infoWinOpen) return

            hideHint(this.slug, this.slide.id);

            const lat = event && event.lngLat ? parseFloat(event.lngLat.lat) : null

            const lng = event && event.lngLat ? parseFloat(event.lngLat.lng) : null

            const paths = this.mapPathsItem()

            const inside = this.insidePolygon(lng, lat)

            if ((!this.dataStore.showPolygon) || (this.dataStore.showPolygon && paths.length && inside)) {

                let marker = markerObject(lat, lng, this.slide.id, this.slide.question)

                toggleOpinionForm(marker)

                addAnswer(marker);

            }

        },

        // används på vissa kartor för att hoppa mellan koordinater
        navigate: function (coordinate) {

            if (coordinate) {

                const keys = Object.keys(coordinate)

                if (keys.includes('lat') && keys.includes('lng')) {

                    const zoom = this.dataStore.currentMapZoom >= 15 ? this.dataStore.currentMapZoom : 15

                    this.map.flyTo({
                        center: [parseFloat(coordinate.lng), parseFloat(coordinate.lat)],
                        zoom: zoom,
                        essential: true
                    })

                }

            }

        },

        toggleOpinion: function (marker) {
            return toggleOpinionForm(marker);
        },

        zoom_changed: function () {

            if (this.$refs[`gmap-${this.dataStore.currentSlide.id}`] !== undefined && this.map) {

                this.dataStore.currentMapZoom = this.map.getZoom()

                this.dataStore.currentMapCenter = this.map.getCenter();

            }

        },

        insidePolygon: function (lng, lat) {

            const paths = this.mapPathsItem()

            if (!paths.length) return

            const point = this.point([lng, lat]);

            const polygon = this.polygon(paths);

            return booleanPointInPolygon(point, polygon)
        },

        setCoordinates: function (event, loopMarker, slide, index) {

            const paths = this.mapPathsItem()

            if (!paths.length) return

            const lng = event.marker._lngLat.lng

            const lat = event.marker._lngLat.lat

            const inside = this.insidePolygon(lng, lat)

            if (inside) {

                this.lastMarker = { lat, lng }

                this.dataStore.currentOpinion = Object.assign({}, loopMarker, { lat, lng });

                this.dataStore.infoWindowPos = Object.assign({}, this.dataStore.infoWindowPos, { lat, lng });

                loopMarker.lat = lat;

                loopMarker.lng = lng;

            }

            else {

                event.marker.setLngLat([this.lastMarker.lng, this.lastMarker.lat])

                this.dataStore.infoWindowPos = Object.assign({}, this.dataStore.infoWindowPos, this.lastMarker)

                this.dataStore.currentOpinion = Object.assign({}, this.dataStore.currentOpinion, this.lastMarker)

            }

        },

        mapPathsItem: function () {

            if (this.slide.item_paths.length) {

                let paths = this.slide.item_paths.map(val => ([parseFloat(val.lng), parseFloat(val.lat)]))

                if (paths[0] !== paths[paths.length - 1]) {
                    paths.push(paths[0])
                }

                paths = [paths];

                return paths
            }

            return [];
        },

        // enitted event from formPopup and currentOpinionWindow to handle remove popup from mapbox
        closePopup: function () {

            if (this.currentPopup && !this.currentPopup.hasOwnProperty('custom')) {
                this.currentPopup.remove()
            }

            this.currentPopup = null
        },

        addSource: function () {

            const deeplink = getSearchParameters(this.project) ? '/' + getSearchParameters(this.project).deeplink : ''

            let data

            if (window.location.pathname.includes('preview-project-report')) {

                const slug = window.location.pathname

                const parts = slug.split('preview-project-report')

                const lastPart = parts[1].replace(/^\/|\/$/g, '')

                const typeParts = lastPart.match(/\/(\w+)\/\d+/)

                const type = typeParts[1]

                if (['good', 'bad', 'goodbad'].includes(type)) {
                    data = '/api/item/geojson/' + this.slide.id + '/type/' + type
                }

            } else {
                data = '/api/item/geojson/' + this.slide.id + deeplink
            }

            if (data !== undefined) {

                this.map.addSource('places', {
                    type: 'geojson',
                    tolerance: 0,
                    data: data
                })

                this.addLayerHeatMap()

            }

            if (window.location.pathname.includes('preview-project-report') && data !== undefined) {
                this.map.setLayoutProperty('heatmap', 'visibility', 'visible');
            }

            if (this.dataStore.selectedFilters.length) {
                this.applyFilters(this.dataStore.selectedFilters)
            }

        },

        addLayerHeatMap: function () {

            this.map.addLayer({
                id: 'heatmap',
                type: 'heatmap',
                source: 'places',
                paint: {
                    'heatmap-opacity': 0.8,
                    'heatmap-radius': 20,
                    'heatmap-weight': [
                        'interpolate',
                        ['linear'],
                        ['get', 'mag'],
                        0, 0,
                        6, 1
                    ],
                    'heatmap-intensity': [
                        'interpolate',
                        ['linear'],
                        ['zoom'],
                        0, 1,
                        9, 3
                    ],
                    'heatmap-color': [
                        'interpolate',
                        ['linear'],
                        ['heatmap-density'],
                        0, 'rgba(0, 0, 255, 0)',
                        0.1, 'royalblue',
                        0.2, 'cyan',
                        0.3, 'lime',
                        0.4, 'yellow',
                        0.5, 'orange',
                        0.6, 'red'
                    ]
                }
            });

            // this.map.setPaintProperty('heatmap', 'heatmap-opacity', 0)
            this.map.setLayoutProperty('heatmap', 'visibility', 'none');

        },

        // Popup window - callbacks mapbox

        onRemovedPopup: function (event) {
            // console.log('removed', event)
        },

        onAddPopup: function (event) {
            // console.log('add', event)
        },

        onClosePopup: function (event) {
            // console.log('close', event)
            document.body.classList.remove('map-popup-open')
            // this.dataStore.showOnMapPopup = false
        },

        onOpenPopup: function (event) {
            // console.log('open', event)
            document.body.classList.add('map-popup-open')
            this.currentPopup = event.popup
        },

        getBounds: function () {

            const paths = this.mapPathsItem()

            if (!paths.length) return null

            const fit = L.polygon(paths[0]).getBounds();

            const southWest = [fit['_southWest']['lat'], fit['_southWest']['lng']];

            const northEast = [fit['_northEast']['lat'], fit['_northEast']['lng']];

            return new mapboxgl.LngLatBounds(southWest, northEast)

        },

        applyFilters: function (values) {

            const mode = this.toggleHeatMap ? 'heatmap' : 'places'

            if( mode === 'heatmap' ) {
                this.map.setFilter(mode, mapBoxFilter(values, this.goodOptions, this.badOptions))
            }
        },


        getMyPosition: function() {

            if(navigator.geolocation) {

                return new Promise((resolve, reject) => 
                    navigator.geolocation.getCurrentPosition(resolve, reject)
                )
                
            } else {

                return new Promise((resolve, reject) => 
                    reject('Geolocation is not supported by this browser.')
                )

            }
        },

        // Slick events from Project slider - dependent on component in this way ProjectSlider -> GoodBadSlide -> MapSlide
        beforeChange: function() {
            this.$parent.$parent.$on('beforeChange', () => {
                this.dataStore.infoWindowPos = { lat: null, lng: null };
                this.dataStore.infoWinOpen = false;
                this.$nextTick(() => this.tiggerOnInit())
            })
        },

        // Slick events from Project slider - dependent on component in this way ProjectSlider -> GoodBadSlide -> MapSlide
        afterChange: function() {
            // this.$parent.$parent.$on('afterChange', () => {})
        },

        // ProjectSlider event - dependent on component in this way ProjectSlider -> GoodBadSlide -> MapSlide
        loadingDone: function() {
            this.$parent.$parent.$parent.$on('loaded', () => {
                this.map.setCenter([parseFloat(this.slide.center_lng), parseFloat(this.slide.center_lat)]);
                this.map.setZoom(this.zoomDefault.zoom)
                this.$nextTick(() => this.fitBounds())
            })
        }

    }

};

</script>
